import { render, staticRenderFns } from "./StartBuyAccount.vue?vue&type=template&id=5a081cee&scoped=true&"
import script from "./StartBuyAccount.vue?vue&type=script&lang=js&"
export * from "./StartBuyAccount.vue?vue&type=script&lang=js&"
import style0 from "./StartBuyAccount.vue?vue&type=style&index=0&id=5a081cee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a081cee",
  null
  
)

export default component.exports